// SEO landing page categories - each maps to a filter query
export const SEO_CATEGORIES = [
  {
    slug: 'house-plans-south-africa',
    title: 'House Plans South Africa | UDS Plans',
    metaDescription: 'Browse our full collection of SA NBR-compliant house plans designed for South African homeowners. Instant digital delivery.',
    heading: 'House Plans South Africa',
    intro: 'Discover our complete range of professionally designed house plans tailored for South African stands and building regulations. Every plan is SA NBR-compliant and ready for local council submission.',
    filters: {}
  },
  {
    slug: '2-bedroom-house-plans',
    title: '2 Bedroom House Plans | UDS Plans',
    metaDescription: 'Compact and affordable 2 bedroom house plans perfect for starter homes, rental units, and small families.',
    heading: '2 Bedroom House Plans',
    intro: 'Ideal for first-time homeowners, rental properties, or small families, our 2-bedroom plans balance affordability with modern comfort.',
    filters: { bedrooms: '2' }
  },
  {
    slug: '3-bedroom-house-plans',
    title: '3 Bedroom House Plans | UDS Plans',
    metaDescription: 'Family-friendly 3 bedroom house plans with spacious living areas and modern layouts.',
    heading: '3 Bedroom House Plans',
    intro: 'The most popular family size, our 3-bedroom plans offer the perfect balance of space, comfort, and cost-effective construction.',
    filters: { bedrooms: '3' }
  },
  {
    slug: '4-bedroom-house-plans',
    title: '4 Bedroom House Plans | UDS Plans',
    metaDescription: 'Spacious 4 bedroom house plans designed for growing families and executive homes.',
    heading: '4 Bedroom House Plans',
    intro: 'Roomy 4-bedroom homes with generous living areas, ideal for growing families or those who work from home.',
    filters: { bedrooms: '4' }
  },
  {
    slug: '5-bedroom-house-plans',
    title: '5 Bedroom House Plans | UDS Plans',
    metaDescription: 'Luxurious 5 bedroom house plans for large families and executive homeowners.',
    heading: '5 Bedroom House Plans',
    intro: 'Our largest family homes, these 5-bedroom designs deliver luxury living with space for extended family and entertaining.',
    filters: { bedrooms: '5' }
  },
  {
    slug: 'modern-house-plans',
    title: 'Modern House Plans | UDS Plans',
    metaDescription: 'Contemporary modern house plans with clean lines, open layouts, and stylish finishes.',
    heading: 'Modern House Plans',
    intro: 'Bold, contemporary designs featuring open-plan living, floor-to-ceiling glass, and clean architectural lines.',
    filters: { style: 'modern' }
  },
  {
    slug: 'farmhouse-house-plans',
    title: 'Farmhouse House Plans | UDS Plans',
    metaDescription: 'Classic farmhouse-style house plans with rustic charm and functional layouts.',
    heading: 'Farmhouse House Plans',
    intro: 'Timeless farmhouse designs featuring pitched roofs, wrap-around verandas, and warm, family-focused interiors.',
    filters: { style: 'farmhouse' }
  },
  {
    slug: 'tuscan-house-plans',
    title: 'Tuscan House Plans | UDS Plans',
    metaDescription: 'Elegant Tuscan-style house plans with Mediterranean-inspired architecture.',
    heading: 'Tuscan House Plans',
    intro: 'Warm, Mediterranean-inspired designs with terracotta accents, arched doorways, and courtyards.',
    filters: { style: 'tuscan' }
  },
  {
    slug: 'single-storey-house-plans',
    title: 'Single Storey House Plans | UDS Plans',
    metaDescription: 'Ground-floor-only house plans, ideal for accessible living and simpler construction.',
    heading: 'Single Storey House Plans',
    intro: 'Everything on one level — perfect for accessibility, easier construction, and elderly-friendly living.',
    filters: { floors: '1' }
  },
  {
    slug: 'double-storey-house-plans',
    title: 'Double Storey House Plans | UDS Plans',
    metaDescription: 'Two-storey house plans maximising floor space on smaller stands.',
    heading: 'Double Storey House Plans',
    intro: 'Get more square metres from a smaller footprint. Ideal for smaller stands or when you want distinct private and living zones.',
    filters: { floors: '2' }
  },
  {
    slug: 'small-house-plans',
    title: 'Small House Plans | UDS Plans',
    metaDescription: 'Compact, efficient small house plans under 100m² for budget-conscious builders.',
    heading: 'Small House Plans',
    intro: 'Efficient use of every square metre. Compact plans under 100m² that punch above their weight in liveability.',
    filters: { max_area: 100 }
  },
  {
    slug: 'house-plans-for-small-stands',
    title: 'House Plans for Small Stands | UDS Plans',
    metaDescription: 'House plans designed for compact stands under 300m².',
    heading: 'House Plans for Small Stands',
    intro: 'Cleverly designed plans that make the most of a small stand without sacrificing comfort.',
    filters: { max_stand: 300 }
  },
  {
    slug: 'affordable-house-plans',
    title: 'Affordable House Plans | UDS Plans',
    metaDescription: 'Budget-friendly house plans starting under R5,000. SA NBR compliant.',
    heading: 'Affordable House Plans',
    intro: 'Great value house plans that keep design fees low without compromising on quality or compliance.',
    filters: { max_price: 5000 }
  },
  {
    slug: 'house-plans-with-garages',
    title: 'House Plans with Garages | UDS Plans',
    metaDescription: 'House plans with integrated garages for one, two, or more vehicles.',
    heading: 'House Plans with Garages',
    intro: 'All the plans in this category include integrated garages for secure vehicle parking.',
    filters: {}
  },
  {
    slug: 'house-plans-under-r7000',
    title: 'House Plans Under R7,000 | UDS Plans',
    metaDescription: 'Affordable house plans priced under R7,000.',
    heading: 'House Plans Under R7,000',
    intro: 'Complete plan sets priced below R7,000 — perfect for budget-conscious builders.',
    filters: { max_price: 7000 }
  }
];

export function getCategoryBySlug(slug) {
  return SEO_CATEGORIES.find(c => c.slug === slug);
}
